import React from 'react';
import { ArrowRight } from 'lucide-react';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  children: React.ReactNode;
  variant?: 'primary' | 'secondary' | 'outline';
  size?: 'sm' | 'md' | 'lg';
  withArrow?: boolean;
  fullWidth?: boolean;
}
export function Button({
  children,
  variant = 'primary',
  size = 'md',
  withArrow = false,
  fullWidth = false,
  className = '',
  ...props
}: ButtonProps) {
  const baseStyles = 'inline-flex items-center justify-center font-medium transition-all duration-300 rounded-2xl';
  const variants = {
    primary: 'bg-terracotta hover:bg-terracotta-dark text-white shadow-soft hover:shadow-lg hover:-translate-y-1',
    secondary: 'bg-sage hover:bg-sage-dark text-white shadow-soft hover:shadow-lg hover:-translate-y-1',
    outline: 'border-2 border-sage text-sage-dark hover:bg-sage hover:text-white'
  };
  const sizes = {
    sm: 'px-4 py-2 text-sm',
    md: 'px-6 py-3 text-base',
    lg: 'px-8 py-4 text-lg md:text-xl'
  };
  const widthClass = fullWidth ? 'w-full' : '';
  return <button className={`${baseStyles} ${variants[variant]} ${sizes[size]} ${widthClass} ${className}`} {...props} data-id="element-23">
      {children}
      {withArrow && <ArrowRight className="ml-2 w-5 h-5" data-id="element-24" />}
    </button>;
}